<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <material-card
          color="purple"
          title="قائمة الاصناف"
          text="جدول بالاصناف الموجودة في النظام لتحديد صلاحيات البرنامج حسب المستخدمين"
        >




          <v-data-table
                    :search="search"
                    :loading="isloading"
                    :loading-text="loadingtext"
                    :headers="headers"
                    :items="items"
                    ref="tbl"
          >

            <template v-slot:top>
              <v-toolbar flat color="white">

                <v-dialog v-model="newDialog">
                  <template v-slot:activator="{ on }">

                    <v-container>
                      <v-row>
                        <v-col cols="12" md="4" xs="12" sm="12">
                            <v-btn large color="purple" dark class="mb-2" v-on="on">إضافة صنف جديدة</v-btn>
                        </v-col>
                        <v-col cols="12" md="8" xs="12" sm="12">
                          <v-text-field
                            filled
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="بحث ..."
                            single-line
                            v-on:key.enter="getGroups"
                            hide-details></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </template>
                  <v-form
                          v-model="valid"
                          lazy-validation
                          ref="form"
                          id="new-form">
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ dialogTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12">
                            <v-text-field
                                    v-model="refer.title"
                                    required
                                    :rules="Rules('nameRules')"
                                    label="اسم الصنف"></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row wrap>
                          <v-card
                             v-for="yy in allperms" :key="yy.id"
                             tile
                          >

                          <v-list dense>
                              <v-checkbox
                                    :label="yy.title_ar"
                                    class="mx-2"
                                    @change="mainCheckBoxClicked(yy)"
                                    :id="yy.value"
                                    :value="yy.id"
                                    v-model="refer.perms">
                              </v-checkbox>
                              <v-list-item-group v-model="item" color="primary">
                              <v-list-item
                                    :ripple="false"
                                    wrap v-for="xx in yy.sub"
                                    :key="xx.id">
                                  <v-list-item-content>
                                    <v-list-item-title></v-list-item-title>
                                      <v-checkbox
                                              :label="xx.title_ar"
                                              class="mx-2"
                                              :id="xx.value"
                                              v-bind:value="xx.id"
                                              v-model="refer.perms">
                                      </v-checkbox>
                                  </v-list-item-content>
                              </v-list-item>
                            </v-list-item-group>
                          </v-list>
                          </v-card>
                        </v-row>
                      </v-container>

                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="newDialog = false">إلغاء</v-btn>
                      <v-btn color="blue darken-1" form="new-form" @click="validateFunc" :disabled="!valid">حفظ</v-btn>
                    </v-card-actions>
                  </v-card>
                  </v-form>
                </v-dialog>



                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">قائمة الاصناف</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="12" md="12" xs="12">
                            <v-card>
                              <v-card-title>
                                    تعديل معلومات الصنف
                              </v-card-title>
                              <v-card-subtitle>
                                يمكنك تعديل اسم الصنف و الصلاحيات المرتبطة به
                              </v-card-subtitle>
                              <v-card-actions>
                                  <v-btn color="primary" dark @click="editRefers">
                                    تعديل
                                  </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close">اغلاق</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>


            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td>{{ item.id }}</td>
              <td>{{ item.title }}</td>
              <td>{{ "xxxx" }}</td>
              <td>{{ item.addby }}</td>
              <td>{{ item.adddate }}</td>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn
                      primary
                      dark
                      center
                      @click="editRefers(item)">
              <v-icon
                      medium
              >
                mdi-pencil
              </v-icon>

              </v-btn>
              <v-btn
                      warning
                      dark
                      @click="deleteItem(item)">
              <v-icon
                      medium
              >
                mdi-delete
              </v-icon>
              </v-btn>
            </template>

          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {__HTTP,FormHeader,__HAS_PERM} from '@/utils/utils';
export default {
  computed: {
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    newDialog (val) {
      val || this.close()
    },
  },
  methods: {
    Rules(type) {
      return this.$store.state.appRules[type];
    },
    getProfiles() {
      __HTTP("?do=getprofiles",{},FormHeader,(res) => {
        console.log(res);
                this.isloading = false
                this.items = res.profiles;
                this.allperms = res.perms
      });

    },
    editRefers (item) {
        this.refer = item
        this.refer.isedit = true;
        this.dialogTitle = "تعديل معلومات الصنف"
        this.newDialog = true
    },

    deleteItem (item) {
      const index = this.items.indexOf(item)
      let c = confirm('Are you sure you want to delete this item?');
      if (c) {
        __HAS_PERM(23,this.$store.state.loggedUser.id,() => {
          __HTTP("?do=delete",{type: "profile",id: item.id},FormHeader,() => {
            this.items.splice(index, 1)
          })
        });
      }
    },
    close () {
      this.dialogTitle = 'إضافة صنف جديد';
      this.refer =
          {
              title: ''
        }
      this.newDialog = false
    },
    validateFunc() {

      if (this.$refs.form.validate()) {
        this.save()
      }
    },
    mainCheckBoxClicked($val) {

      if (this.refer.perms.includes($val.id)) {
        $val.sub.map((i) => {
          console.log("Insert",i.id);
          let ind = this.refer.perms.indexOf(i.id);
          if (ind > -1)
            this.refer.perms.splice(ind,1)
          this.refer.perms.push(i.id);
        });
      } else {
        $val.sub.map((i) => {
          let ind = this.refer.perms.indexOf(i.id);
          this.refer.perms.splice(ind,1)
        });
      }
    },
    save () {
      __HTTP("?do=newprofile",{
        title: this.refer.title,
        perms: this.refer.perms,
        permstext: this.refer.permstext,
        isedit: this.refer.isedit ? true : false,
        id: this.refer.id
      }, FormHeader, (res) => {
        if (this.refer.isedit) {
          var index = this.items.findIndex(obj => obj.id == res.id);
          this.items.splice(index,1,res)
        } else {
          this.items.push(res);
        }
        this.refer.isedit = false;
        this.dialogTitle = 'إضافة صنف جديد'
          this.newDialog = false;
      });
    },
  },
  created() {
     this.getProfiles();
    },
  data: () => ({
    valid: true,
    dialogTitle: 'إضافة صنف جديد',
    search: '',
    newDialog: false,
    isloading: true,
    loadingtext: "يرجى الانتظار جاري تحميل البيانات",
    dialog: false,
    toBeEdit: null,
    item: {},
    refer:
      {
        title: '',
        perms: [],
        isedit: false
      },
        headers: [
      {
        sortable: true,
        text: '#',
        value: 'id',
        align: 'right'
      },
      {
        sortable: true,
        text: 'اسم الصنف',
        value: 'title',
        align: 'right'
      },
      {
        sortable: true,
        text: 'صلاحيات الصنف',
        value: 'permstext',
        align: 'right'
      },
      {
        sortable: true,
        text: 'اضيفت بواسطة',
        value: 'addby',
        align: 'right'
      },
      {
        sortable: true,
        text: 'اضيفت بتاريخ',
        value: 'adddate',
        align: 'right'
      },
      { text: 'الادوات', value: 'action', sortable: false },
    ],
    items: [

    ],
    allperms: []
  })
}
</script>
